
import { IconButton, Modal, PrimaryButton } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
// import Timeline from 'timeline';
import "../Styles/TATTimelineCss.css";
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { useTranslation } from "react-i18next";
import ModalMain from '../../../../components/Modal/ModalMain';
import TATTimelineBody from './TATTimelineBody';
import { getAverageTatAPI, showStatusAPI } from '../../../../service/StudyListService';
import loaderContext from '../../../../context/loader/LoaderContext';
import { getEnv } from '../../../../helpers/EnvHelper';

const TATTimeline = (props) => {

  const [estimateTime, setEstimateTime] = useState("");
  const [timelineStatus, setTimelineStatus] = useState([]);
  const [otherTimeline, setOtherTimeline] = useState([]);
  const {ref, setLoaderRunning} = useContext(loaderContext);
  const [studyCloseData, setStudyCloseData] = useState({});
  const [timelineData, setTimelineData] = useState("");

    const [t] = useTranslation();

    const hideTATTimelineModal = () =>{
      props.setShowTATTimelineModal(false);
    }

    const fetchAverageTatAPI = async() =>{
      const response = await getAverageTatAPI(props.modalityName);
      const time = response.data.data;
      setEstimateTime(time);
    }

    const fetchStudyTimelines = async() => {
      setLoaderRunning(true);
      ref.current.continuousStart();
      let payload = {
        studyId: props.studyId,
        firmId: props.firmId,
        providerId: props.providerId
      }
      try{const response = await showStatusAPI(payload);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        let data = response.data.data;
        setStudyCloseData(response?.data?.data);
        let timelineData = [
          {            
            name: t("tat-timeline.items.study-date"),
            active: data.studyDateDisplay != null ? true : false,
            time: data.studyDateDisplay,
          },
          {
            name: t("tat-timeline.items.study-uploaded"),
            active: data.uploadDateString != null ? true : false,
            time: data.uploadDateString,
            diff: data.studyUploadDiffString
          },
          {
            name: t("tat-timeline.items.last-history-updated"),
            active: (data.historyUploadDateString != null || data.assignmentDateString != null) ? true : false,
            time: data.historyUploadDateString != null ? data.historyUploadDateString : "NA",
            diff: data.uploadHistoryDiffString
          },
          {
            name: t("tat-timeline.items.assigned-to-radiologist"),
            active: data.assignmentDateString != null ? true : false,
            time: data.assignmentDateString,
            diff: data.historyAssignmentDiffString
          }
        ];
        timelineData.push({
          name: t("tat-timeline.items.report-preliminary"),
          active: data.reportSaveDateString != null ? true : false,
          time: data.reportSaveDateString,
          diff: data.assignmentSaveDiffString
        });
        timelineData.push({
          name: t("tat-timeline.items.report-submitted"),
          active: data.reportSubmitDateString != null ? true : false,
          time: data.reportSubmitDateString,
          diff: data.assignmentReportDiffString
        });
        let isVDCPlatform = getEnv("REACT_APP_VDC_PLATFORM");
        if(isVDCPlatform){
          timelineData.unshift(
            {
              name : t('tat-timeline.items.registration-date-time'),
              active: (data.registrationDateTime != null && data.registrationDateTime != "-") ? true : false,
              time : data.registrationDateTime == '-' ? null : data.registrationDateTime
            }
          )
        }
        console.log("timeline data", timelineData);
        setTimelineStatus(timelineData);
        setOtherTimeline(data.otherTimelineList);
        setTimelineData(data);
        setLoaderRunning(false);
      ref.current.complete();
      }else{
        setLoaderRunning(false);
        ref.current.complete();
      }}catch(e){
        setLoaderRunning(false);
        ref.current.complete();
      }
    }

    useEffect(()=>{
      fetchAverageTatAPI();
      fetchStudyTimelines();
    },[props.studyId]);


    let DefaultButtonList = [
      {
          title:t("button.close"),
          onclick: hideTATTimelineModal
      }
    ]

    const Containerstyles=  {
      root:{
        backgroundColor: 'rgb(22, 21, 20, 0.7)'
     },
      main:{
        boxSizing: "border-box",
        borderRadius: "10px 10px 10px 10px",
        fontFamily: "Open Sans",
        fontStyle: "normal",
        boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        width : "785px",
      },
      // modalBody:{
      //   padding: "20px",
      //   backgroundColor: "#191919",
      //   border:"1px solid white",
      // }
    }

  const modalDetails = {
    header: <ModalHeader updatedModal={true} patientName={props.patientName} patientID={props.patientId} heading={t("tat-timeline.title")} handleCancel={hideTATTimelineModal}/>,
    body: <TATTimelineBody studyCloseData={studyCloseData} data={props.data} estimateTime={estimateTime} timelineStatus={timelineStatus} otherTimeline={otherTimeline} timelineData={timelineData} studyId={props.studyId}/>,
    footer: <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={[]}/>,
    width: "785px"
  }
  return (
    <>
      {props.showTATTimelineModal && 
        <ModalMain showModal={props.showTATTimelineModal} modalDetails={modalDetails}/>
      }
    </>
  )
}

export default TATTimeline